// Mapeo local POS -> id del catálogo DIAN (scope: null, facturación).
// El API DIAN espera el id entero, NO el code string ("31", "13"...) ni el código local ("NIT", "CC").
//
// Referencia: catálogo /type_document_identifications del API DIAN. Los IDs aquí
// corresponden a las entradas con scope=null. Las entradas duplicadas con
// scope="health"/"reception" tienen códigos cortos coincidentes (CC, NIT, CE...)
// pero IDs distintos que rompen el envío DIAN si se usan por error.
const LOCAL_TO_DIAN_ID = {
  RC: 1,
  TI: 2,
  CC: 3,
  TE: 4,
  CE: 5,
  NIT: 6,
  PAS: 7,
  DEX: 8,
  NUIP: 10,
  PEP: 24,
  PPT: 38,
};

const VALID_DIAN_IDS = new Set([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 24, 38]);

// Resuelve el type_document_identification_id que se envía al API DIAN.
// Acepta string local (CC/NIT/CE...), número ya mapeado, o string numérico.
// Fallback final usa type_organization: persona jurídica -> NIT (6), si no -> CC (3).
export function resolveDianDocTypeId(partyTypeId, type_organization) {
  if (partyTypeId === null || partyTypeId === undefined || partyTypeId === '') {
    return fallbackByOrg(type_organization, 'partyTypeId vacío');
  }

  // Si ya es número válido del catálogo DIAN, devolverlo.
  if (typeof partyTypeId === 'number' && VALID_DIAN_IDS.has(partyTypeId)) {
    return partyTypeId;
  }

  const raw = String(partyTypeId).trim();

  // Numérico en string ("3", "6"): aceptar si es un id válido.
  if (/^\d+$/.test(raw)) {
    const asInt = parseInt(raw, 10);
    if (VALID_DIAN_IDS.has(asInt)) return asInt;
  }

  // Tabla hard-coded local -> id.
  const upper = raw.toUpperCase();
  if (LOCAL_TO_DIAN_ID[upper] != null) {
    return LOCAL_TO_DIAN_ID[upper];
  }

  // Respaldo: catálogo en window.settings, filtrado a scope null (facturación DIAN).
  // Las entradas health/reception comparten códigos como "CC"/"NIT" pero con
  // IDs distintos — incluirlas aquí rompe el envío.
  const catalog =
    (typeof window !== 'undefined' &&
      window.settings &&
      Array.isArray(window.settings.type_document_identifications))
      ? window.settings.type_document_identifications
      : [];

  const match = catalog.find((entry) => {
    if (!entry || entry.scope != null) return false;
    const code = entry.code != null ? String(entry.code).toUpperCase() : '';
    const name = entry.name != null ? String(entry.name).toUpperCase() : '';
    return code === upper || name === upper;
  });

  if (match && VALID_DIAN_IDS.has(parseInt(match.id, 10))) {
    return parseInt(match.id, 10);
  }

  return fallbackByOrg(type_organization, `partyTypeId no reconocido: "${raw}"`);
}

function fallbackByOrg(type_organization, reason) {
  const orgId = parseInt(type_organization, 10);
  const fallback = orgId === 1 ? 6 : 3;
  console.warn(
    `[dianDocTypes] Fallback a ${fallback === 6 ? 'NIT' : 'CC'} (id=${fallback}). Motivo: ${reason}`
  );
  return fallback;
}

export default resolveDianDocTypeId;
